var map = {
	"./events-cat.webp": 2087,
	"./games-cat.webp": 2088,
	"./live-casino-cat.webp": 2089,
	"./lottery-cat.webp": 2090,
	"./other-cat.webp": 2091,
	"./p2p-cat.webp": 2092,
	"./pd-table.webp": 2093,
	"./privacy-policy-title-bm.webp": 2094,
	"./privacy-policy-title-cn.webp": 2095,
	"./privacy-policy-title-id.webp": 2096,
	"./privacy-policy-title.webp": 2097,
	"./promos-1.webp": 2098,
	"./promos-2.webp": 2099,
	"./promos-3.webp": 2100,
	"./promos-4.webp": 2101,
	"./question.webp": 2102,
	"./sideBar-bg.webp": 2103,
	"./slot-cat.webp": 2104,
	"./special-cat.webp": 2105,
	"./sports-cat.webp": 2106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 480;